import API from "./api"; // Import the base API configuration

const GUNS_BASE_URL = "/guns"; // Define base route for guns

/**
 * Registers a new gun.
 * @param {Object} gunData - { productId, serialNumber }
 * @returns {Promise<Object>} - API response
 */
export const registerGun = async (gunData) => {
    try {
        const response = await API.post(`${GUNS_BASE_URL}/register`, gunData);
        return response.data;
    } catch (error) {
        console.error("Error registering gun:", error.response?.data || error.message);
        throw error;
    }
};

/**
 * Fetches all guns with optional pagination.
 * @param {number} [limit=10] - Number of records per page
 * @param {number} [offset=0] - Offset for pagination
 * @returns {Promise<Array>} - List of guns
 */
export const getAllGuns = async (limit = 10, offset = 0) => {
    try {
        const response = await API.get(`${GUNS_BASE_URL}/all?limit=${limit}&offset=${offset}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching guns:", error.response?.data || error.message);
        throw error;
    }
};

/**
 * Fetches details of a single gun by ID.
 * @param {number} gunId - Gun ID
 * @returns {Promise<Object>} - Gun details
 */
export const getGunById = async (gunId) => {
    try {
        const response = await API.get(`${GUNS_BASE_URL}/${gunId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching gun with ID ${gunId}:`, error.response?.data || error.message);
        throw error;
    }
};

/**
 * Updates a gun's details.
 * @param {number} gunId - Gun ID
 * @param {Object} updatedData - { productId, serialNumber, status }
 * @returns {Promise<Object>} - API response
 */
export const updateGun = async (gunId, updatedData) => {
    try {
        const response = await API.put(`${GUNS_BASE_URL}/update/${gunId}`, updatedData);
        return response.data;
    } catch (error) {
        console.error(`Error updating gun with ID ${gunId}:`, error.response?.data || error.message);
        throw error;
    }
};

/**
 * Deletes a gun by ID.
 * @param {number} gunId - Gun ID
 * @returns {Promise<Object>} - API response
 */
export const deleteGun = async (gunId) => {
    try {
        const response = await API.delete(`${GUNS_BASE_URL}/delete/${gunId}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting gun with ID ${gunId}:`, error.response?.data || error.message);
        throw error;
    }
};
